import ProviderList from '@/pages/routing/global/ProviderList.vue'
import ProviderForm from '@/pages/routing/global/ProviderForm.vue'

export default [
  {
    path: '/routing/provider',
    component: ProviderList
  },
  {
    path: '/routing/provider/provider_form/:mode/:id',
    component: ProviderForm,
    props: true
  },
]
